import styled from "styled-components";

export const CustomTooltipWrapper = styled.div`
  background-color: #fff;
  margin: 0;
  padding: 10px;
  border: 1px solid #ccc;
  white-space: nowrap;
`;

export const CustomTooltipLi = styled.li`
  display: block;
  padding-top: 4px;
  padding-bottom: 4px;
  color: ${({ color }) => color};
`;
